<template>
  <div>
    <!-- TODO: refactor markup using the data in 'menu'Secondary Menu Component -->
    <!-- {{ menu }} -->
    <span v-for="(route, index) in menu" :key="index">
      <b-link :to="{name:route.routeName}" class="btn btn-outline-light btn-sm">
        <b-icon :icon="route.icon"></b-icon> <small class="d-none d-sm-inline">{{route.label}}</small>
      </b-link>
    </span>
  </div>
</template>

<script>
import { secondary } from '../nav'

export default {
  data () {
    return {
      menu: secondary
    }
  }
}
</script>
